import { useState, type ReactNode } from 'react';

/** A small (i) circle that toggles an explanation panel below its row. */
export default function InfoDot({ children }: { children: ReactNode }): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="What is this?"
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full border text-sm leading-none transition ${
          open ? 'border-cyan text-cyan' : 'border-text-secondary/50 text-text-secondary hover:border-cyan hover:text-cyan'
        }`}
      >
        i
      </button>
      {open && (
        <div className="w-full mt-1 rounded-lg bg-warm-dark-2/50 border border-warm-dark-2 p-3 text-sm text-text-secondary space-y-2">
          {children}
        </div>
      )}
    </>
  );
}
